import React from 'react';
import { createBrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import Root from './Root';
import Chat from './Chat';
import { SetCookie } from '~/utils/cookie';
import { setFlags } from '~/utils/main';

const ErrorComponent = () => <h1>Something went wrong. Please refresh the page and try again.</h1>;

const RootRedirect = () => {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    setFlags();
    SetCookie("reg_google", "on", { domain: '.ai-pro.org' });
    SetCookie("reg_apple", "on", { domain: '.ai-pro.org' });
    navigate('/chat/new', { replace: true });
  }, [navigate]);

  return null;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    // errorElement: <ErrorComponent></ErrorComponent>,
    children: [
        {
          index: true,
          element: <RootRedirect />,
        },
        {
          path: 'chat/:conversationId?',
          // errorElement: <ErrorComponent></ErrorComponent>,
          element: <Chat />,
        }
    ]
  }
]);
